import ShareTaxi from '@/views/ShareTaxi/index.vue'

const ShareTaxiRouter = {
  path: '/share-taxi',
  name: 'ShareTaxi',
  component: ShareTaxi,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default ShareTaxiRouter
